<div id="dashboard-analytics" class="page-layout blank">
    <div class="content">
        <div *ngIf="reservations.length==0" class="p-16 font-size-24">
            {{ 'No upcoming classes found'|translate }}
        </div>
        <table class="table" style="padding: 10px;" *ngIf="reservations.length>0">
            <thead>
            <tr>
                <th>#</th>
                <th>{{'Start date'|translate}}</th>
                <th>{{'End date'|translate}}</th>
                <th>{{'Participants quantity'|translate}}</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let reservation of reservations; let i = index">
                <th scope="row">{{i + 1}}.</th>
                <td>{{reservation.startDate|date: 'dd.MM.y':'UTC': 'pl'}}</td>
                <td>{{reservation.endDate|date: 'dd.MM.y':'UTC': 'pl'}}</td>
                <td>{{reservation.groupActivity.participants.length}}</td>
                <td><a routerLink="/calendar/group-activity/{{reservation.id}}">{{'Details'|translate}}</a></td>
                <td><a routerLink="/training/{{reservation.id}}">{{'Go to activity'|translate}}</a></td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
